var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VTextArea"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows},domProps:{"value":(_vm.localValue)},on:{"input":[function($event){if($event.target.composing)return;_vm.localValue=$event.target.value},_vm.input]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }